import { WebViewerInstance } from '@pdftron/webviewer';
import { WatermarkDMS } from '../../../shared/types';

export function setWatermarkOptions(ins: WebViewerInstance, watermark: WatermarkDMS) {
 
    if (!watermark) return;
    if (watermark.textWatermark) {
        if(!watermark.fontFamily) {
            watermark.fontFamily = 'sans-serif';
        } 
        ins?.Core.documentViewer.setWatermark({
            diagonal: {
                fontSize: watermark.fontSize,
                fontFamily: watermark.fontFamily,
                color: watermark.color,
                opacity: watermark.opacity,
                text: watermark.textWatermark,
            }, shouldDrawOverAnnotations: true
        });
    } else {
        ins?.Core.documentViewer.setWatermark({
            diagonal: {
                fontSize: watermark.fontSize,
                fontFamily: watermark.fontFamily,
                color: watermark.color,
                opacity: watermark.opacity,
                text: watermark.text,
            }, shouldDrawOverAnnotations: true
        });
    }
}

export function setClearWatermarkOptions(ins: WebViewerInstance) {
    ins?.Core.documentViewer.setWatermark({
        diagonal: {
            fontSize: 8,
            color: '#FFFFFF',
            opacity: 0,
            text: ''
        }, shouldDrawOverAnnotations: true
    });
}